import axios from 'axios'
import AuiToast from '../../assets/js/aui-toast'

const isTest = false
function extensionPath() {
  return isTest ? 'test/' : ''
}

const hideLoading = () => AuiToast.hide()
const showLoading = () => {
  AuiToast.loading({ title: 'loading...', duration: 2000 }, function () { })
}

/**
 * 0x42 读取充电桩状态
 * @param {String[]} sns SN 集合（8位十六进制大写）
 */
const readChargeStationStatus = async (sns) => {
  showLoading()
  return axios.post(`/api/jvcom/dtu/${extensionPath()}accessor/processor-protocol/down-charge-station-status-read`, {
    sns
  }).then(res => {
    hideLoading()
    return res
  })
}

/**
 * 0x43 读取充电桩参数
 * @param {String[]} sns SN 集合（8位十六进制大写）
 */
const readChargeStationParam = async (sns) => {
  showLoading()
  return axios.post(`/api/jvcom/dtu/${extensionPath()}accessor/processor-protocol/down-charge-station-param-read`, {
    sns
  }).then(res => {
    hideLoading()
    return res
  })
}

/**
 * 0x44 设置充电桩参数
 * @param {Object} params
 *   sns: String[]           SN 集合
 *   code: Number            参数编号
 *   batteryDischargeVoltage: Number 电池放电电压(mV)
 *   batteryProtectVoltage: Number   电池保护电压(mV)
 *   batteryMaxDischargePower: Number 电池放电最大功率(W)
 *   pvAdjustMinPower: Number        光伏调整最低功率(W)
 *   inverterMinOutputVoltage: Number 逆变输出最小电压(V)
 *   cableOverTempProtectTemp: Number 线缆过温保护温度(倍率100)
 *   cableOverTempRecoverTemp: Number 线缆过温保护恢复温度(倍率100)
 *   mainBoardOverTempProtectTemp: Number 主控板过温保护温度(倍率100)
 *   mainBoardOverTempRecoverTemp: Number 主控板过温保护恢复温度(倍率100)
 *   inverterFetchInterval: Number    定时获取逆变器间隔(ms)
 *   connectCPVoltageThreshold: Number  接入CP电压阈值(mV)
 *   chargeCPVoltageThreshold: Number  充电CP电压阈值(mV)
 *   cpPowerInitRatio: Number           CP功率初始调节比例(0-1000)
 *   cpPowerMinRatio: Number            CP功率下限调节比例(0-1000)
 *   cpPowerMaxRatio: Number            CP功率上限调节比例(0-1000)
 */
const setChargeStationParam = async (params) => {
  showLoading()
  return axios.post(`/api/jvcom/dtu/${extensionPath()}accessor/processor-protocol/down-charge-station-param-set`, params)
    .then(res => {
      hideLoading()
      return res
    })
}

/**
 * 查询充电桩最新状态（pcs_charge_station_status）
 * @param {String} sn 8位十六进制大写
 */
const findLatestStatus = async (sn) => {
  showLoading()
  return axios.post(`/api/jvcom/dtu/${extensionPath()}manager/charge-station/latest-status`, { sn })
    .then(res => {
      hideLoading()
      return res
    })
}

/**
 * 查询充电桩状态历史（pcs_charge_station_status_record）
 * @param {String} sn SN
 * @param {String} queryDate YYYY-MM-DD
 * @param {String} [beginDate] YYYY-MM-DD
 * @param {String} [endDate] YYYY-MM-DD
 */
const findStatusHistory = async (sn, queryDate, beginDate, endDate) => {
  showLoading()
  const params = { sn, queryDate }
  if (beginDate) params.beginDate = beginDate
  if (endDate) params.endDate = endDate
  return axios.post(`/api/jvcom/dtu/${extensionPath()}manager/charge-station/status-history`, params)
    .then(res => {
      hideLoading()
      return res
    })
}

/**
 * 查询充电桩最新一次参数设置（pcs_charge_station_param）
 * @param {String} sn
 */
const findLatestParamSet = async (sn) => {
  showLoading()
  return axios.post(`/api/jvcom/dtu/${extensionPath()}manager/charge-station/latest-param`, { sn })
    .then(res => {
      hideLoading()
      return res
    })
}

/**
 * 查询充电桩主动上报记录（pcs_charge_station_active_report）
 * @param {String} sn
 * @param {Number} [reportCode] 上报编码（0x07 充电枪工作状态变化）
 */
const findActiveReports = async (sn, reportCode) => {
  showLoading()
  const params = { sn }
  if (reportCode !== undefined && reportCode !== null) params.reportCode = reportCode
  return axios.post(`/api/jvcom/dtu/${extensionPath()}manager/charge-station/active-report`, params)
    .then(res => {
      hideLoading()
      return res
    })
}

const pcs = {
  readChargeStationStatus,
  readChargeStationParam,
  setChargeStationParam,
  findLatestStatus,
  findStatusHistory,
  findLatestParamSet,
  findActiveReports
}
export default pcs